import React, { useState } from "react";
import LabelTag from "../reusebale/label";
import { Link } from "react-router-dom";
import db from "../../db/index.json";
import ButtonTag from "../reusebale/button";
import ParagraphTag from "../reusebale/Paragraph";
import MyLoader from "../../component/reusebale/myLoader";
import BaseUrl from "../../constants/BaseUrl";
import { ShowError, ShowSuccess } from "../../utils/ToasFunction";
import { useSelector, useDispatch } from "react-redux";
import * as AuthAction from "../../store/actions/auth/AuthAction";
import { useNavigate } from "react-router-dom";
const ForgetFormSection = (props) => {
  const { verification } = db;
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [loaderVerify, setLoaderVerify] = useState(false);
  const [loader, setLoader] = useState(false);
  const [otpData, setOtpData] = useState();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const VerifyHandler = (e) => {
    e.preventDefault();

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!email) {
      ShowError("Email address is required");
      return;
    }

    if (!emailRegex.test(email)) {
      ShowError("Please enter a valid email address");
      return;
    }

    setLoader(true);
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
      email: email,
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(`${BaseUrl}api/forgotpassword/forgotPassOtpCreate`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "success") {
          ShowSuccess(result.message);
          setLoader(false);
          setOtpData(result.data);
        } else {
          ShowError(result.message);
          setLoader(false);
        }
      })
      .catch((error) => console.error(error));
    // setLoader(true);
  };

  const VerifyOtpHandler = (e) => {
    e.preventDefault();

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const otpRegex = /^\d{5}$/; // ✅ exactly 5 digits

    if (!email) {
      ShowError("Email address is required");
      return;
    }

    if (!emailRegex.test(email)) {
      ShowError("Please enter a valid email address");
      return;
    }

    if (!otp) {
      ShowError("OTP is required");
      return;
    }

    if (!otpRegex.test(otp)) {
      ShowError("OTP must be exactly 5 digits");
      return;
    }
    setLoaderVerify(true);
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
      recordId: otpData._id,
      otp: otp,
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(
      `${BaseUrl}api/forgotpassword/verifyForgotPassOtpCode`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "success") {
          ShowSuccess(result.message);
          setLoaderVerify(false);
          dispatch(AuthAction.ForgotPasswordUserIdAction(result.userId));
          navigate("/reset-password");
        } else {
          ShowError(result.message);
          setLoaderVerify(false);
        }
      })
      .catch((error) => console.error(error));
  };

  return (
    <form className="mt-8">
      <div className="w-full mt-3 flex flex-col lg:flex-row lg:justify-between">
        <div class="w-full lg:w-[48%]">
          <LabelTag name={verification.emailLabel} isStaric={false} />
          <div className="w-full relative">
            <input
              onChange={(e) => {
                setEmail(e.target.value);
              }}
              value={email}
              type="text"
              placeholder="Enter your email.."
              className="w-full mt-1 font-popinsRegular bg-bgColor px-3 py-2 text-sm rounded-lg text-darkColor placeholder:text-zinc-700/50 pr-16"
            />
            <div className="absolute top-[6px] right-[2px]">
              {loader ? (
                <div>
                  <MyLoader />
                </div>
              ) : (
                <ButtonTag
                  onSubmit={VerifyHandler}
                  name={verification.verify}
                  disabled={!email}
                  classes="text-xs px-2 bg-themeColor hover:bg-themeColor/90 text-center text-white disabled:bg-gray-400 disabled:cursor-not-allowed"
                />
              )}
            </div>
          </div>
        </div>
        <div class="w-full lg:w-[48%] mt-4 lg:mt-0">
          <LabelTag name={verification.otpLabel} isStaric={false} />
          <div className="w-full relative">
            <input
              onChange={(e) => {
                setOtp(e.target.value);
              }}
              value={otp}
              type="text"
              placeholder="Enter OTP"
              className="w-full mt-1 font-popinsRegular bg-bgColor px-3 py-2 text-sm rounded-lg text-darkColor placeholder:text-zinc-700/50"
            />
          </div>
        </div>
      </div>
      {loaderVerify ? (
        <div className="flex w-screen ">
          <MyLoader />
        </div>
      ) : (
        <ButtonTag
          onSubmit={VerifyOtpHandler}
          name="Submit"
          disabled={!otp}
          classes="mt-5 text-base text-center bg-themeColor text-white mb-8 lg:mb-0 disabled:bg-gray-400 disabled:cursor-not-allowed"
        />
      )}

      {/* <ButtonTag name={verification.verifyMainBtn} classes='text-base bg-themeColor hover:bg-themeColor/90 mt-5 text-center text-white' /> */}
      {/* <div className="w-full text-center pt-5">
        <ParagraphTag
          content={verification.msgOtp}
          classes="text-[#686868] font-popinsRegular text-sm"
        />
        <ParagraphTag
          content={verification.resend}
          classes="text-themeColor font-popinsRegular text-sm cursor-pointer"
        />
      </div> */}
      <div className="flex items-center my-2">
        <div className="w-[15%] lg:w-[30%] bg-[#1A1A1A]/30 h-[1px]"></div>
        <div className="w-[70%] lg:w-[40%] flex justify-center">
          <ParagraphTag
            content="Login to a different account"
            classes="text-[#686868] font-popinsRegular text-sm"
          />
        </div>
        <div className="w-[15%] lg:w-[30%] bg-[#1A1A1A]/30 h-[1px]"></div>
      </div>
      <Link to={"/login"}>
        <ButtonTag
          name="Log In"
          classes="text-base text-center border-2 border-themeColor text-themeColor mb-8 lg:mb-0"
        />
      </Link>
    </form>
  );
};

export default ForgetFormSection;
